import { Wording } from '@/types';

export const LOVE_WORDING_FI: Wording = {
  components_header_media_content: 'Äänet',
  components_header_media_1: 'Meditaatiot',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Oppaat',
  components_header_text2: 'Blogi',
  components_header_members: 'jäsenet',
  hero_text: 'Löydä rakkaus tähtien läpi',
  hero_button_text: 'Aloita matkasi',
  components_ressources_section_title: 'RAKKAUS & ASTROLOGIA',
  components_ressources_subheader_text: 'Taivaallinen työkalupakki romanttiseen näkemykseen',
  components_ressources_span_text: 'Sukella podcastien ja artikkeleiden universumiimme, joka keskittyy rakkauteen, horoskooppiyhteensopivuuteen ja kosmiseen yhteyteen. Etsitpä sitten sielunkumppanin selkeyttä tai dekoodaat suhdemallejasi, resurssimme ohjaavat sinut syvempään ymmärtämiseen tähtien kautta.',
  components_ressources_card_1_title: 'Zodiac Love Talks',
  components_ressources_card_1_text: 'Tutustu sydämellisiin podcast-jaksoihin perehtymällä kunkin merkin tunnekieleen, rakkauden yhteensopivuuteen, intohimoon ja ihmissuhteiden henkilökohtaiseen kasvuun.',
  components_ressources_card_2_title: 'Rakkaus blogi',
  components_ressources_card_2_text: 'Lue oivalluksia ja pohdintoja siitä, kuinka kukin merkki rakastaa, parantaa ja yhdistää. Synastista planetaariseen romantiikkaan, blogimme on oppaasi astrologiseen rakkauteen.',
  components_ressources_link: 'Tutustu tarkemmin',
  components_notes_and_google_title_1: 'Romanttinen astrologia',
  components_notes_and_google_title_2: 'Rakkaustavat',
  components_notes_and_google_title_3: 'Kuuntelijoiden rakkauden heijastuksia',
  components_review_google_text: 'Mitä kuuntelijamme sanovat',
  media_content_section_title: 'LOVE & ZODIAC PODCAST',
  media_content_section_subheader_text: 'Todellinen keskustelu kosmisesta romanssista',
  text_media_1: 'Viritä syviin, paljastaviin jaksoihin astrologisista otteluista, tunnekuvioista ja romanttisesta dynamiikasta.',
  text_media_2: '',
  media_content_section_button_more: 'Kuuntele nyt',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Astrologisia rakkaustarinoita ja oivalluksia',
  text2_section_button_more: 'Lataa lisää',
  components_text1_section_title: 'OPPAAT',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Anna tähtien ohjata rakkaustarinasi',
  components_footer_info: 'Tiedot',
  components_footer_registration_number: 'Rekisterinumero',
  components_footer_legal: 'Laillinen',
  components_footer_terms: 'Ehdot',
  components_footer_privacy: 'Tietosuojakäytäntö',
  button_load_more: 'Lataa lisää',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Rakkaus & Zodiac: Podcast-jaksot',
  page_media_content_menu_compatibility: 'Yhteensopivuus',
  page_media_content_menu_love: 'Rakkaus',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Tutki rakkautta astrologian avulla',
  page_text2_section_title: 'Blogi',
  page_text2_subheader_text: 'Artikkelit',
  enter_email_title: 'Anna sähköpostiosoitteesi jatkaaksesi',
  enter_email_placeholder_email: 'Sähköposti',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Kirjautuminen onnistui!',
  components_card_link_media_content: 'Kuuntele nyt',
  components_card_link_text2_content: 'Lue artikkelit',
  components_card_link_text1_content: '',
  france: 'Ranska',
  cyprus: 'Kypros',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditaatio',
  page_media_content_menu_all: 'Kaikki',
};